import { LayoutProvider } from '#Context/Layout'
// import { BackgroundProvider } from '#Context/Background'
import { LoadingProvider } from '#Context/Loading'
import { GeneralContextProvider } from '#Context/General'
import { ModalProvider } from '#Context/Modal'
import { BlogProvider } from '#Context/Blog'
import { Outlet, } from 'react-router-dom'

export default function AllContexts() {
    return (
        <LayoutProvider>
            <LoadingProvider>
                <GeneralContextProvider>
                    <ModalProvider>
                        <BlogProvider>
                            <Outlet></Outlet>
                        </BlogProvider>
                    </ModalProvider>
                </GeneralContextProvider>
            </LoadingProvider>
        </LayoutProvider>
    )
}